<template>
    <div>
      <b-overlay :show="creatingOrder" rounded="sm">
      <div class="orders-container">
        <b-container fluid>
          <ul class="total-amount">
            <li class="total-item">Order Totals: ${{ totalOrderAmount.toFixed(2) }}</li>
            <li class="total-item">Item Totals: ${{ totalItemAmount.toFixed(2) }}</li>
            <li class="total-item">Cancelled Orders: {{ cancelledOrdersCount }}</li>
          </ul>
            <b-overlay :show="isLoading" rounded="sm">

            <b-row class="mt-4">
                <b-col>
                    <order-menu :selected="selected"
                                :rowCount="orders.length"
                                :selectRange="selectRange"
                                :showPrintButton="false"
                                :busy="isLoading || creatingOrder"
                                @selectAll="$refs.customerOrdersTable.selectAllRows()"
                                @clearSelected="$refs.customerOrdersTable.clearSelected()"
                                @printSelected="printSelected()"
                                @previewInvoice="previewInvoice()"
                                @sendInvoice="sendInvoice()"
                                @newOrder="newOrder()"
                                @setSelectRange="setSelectRange()"
                                @refresh="refreshSearch()"
                                @removeCombined="removeCombined()"
                                >
                    </order-menu>
                              
                </b-col>
            </b-row>
            </b-overlay>
        </b-container>

        <div class="scrollable-container">
  

            <b-table primary-key="order" selectable sticky-header small no-border-collapse
                    class="orders-table"
                     :select-mode="(selectRange ? 'range' : 'multi')"
                     :items="orders"
                     :fields="fields"
                     @row-selected="rowSelected"
                     ref="customerOrdersTable">

                <template #cell(orderId)="row">
                  <b-link :to="{ name: 'orders', params: { outsideQuery: { orderId: row.value.toString(), query: row.value.toString(), filters: {} } } }" append >{{ row.value }}</b-link>
                </template>

                <template #cell(orderTotal)="data">
                    <span class="text-success">
                        ${{ data.value ? data.value.toFixed(2) : '0' }}
                    </span>
                </template>

                <template #cell(shipping)="data">
                    <h5 class="mb-0 text-primary" v-if="data.value" ><b-icon-check-circle-fill></b-icon-check-circle-fill></h5>
                    <h5 class="mb-0 text-secondary" v-else><b-icon-x-circle-fill></b-icon-x-circle-fill></h5>
                </template>

                <template #cell(printing)="data">
                    <span class="text-secondary">
                        <b-button class="print-tooltip-button" :id='data.item._id' v-if="data.value" size="sm" variant="link"><h5 class="mb-0 text-primary" style="width: 20px; height: 20px; font-size: 100%;"><b-icon-check-circle-fill class="mt-0" style="width: 20px; height: 20px;"></b-icon-check-circle-fill></h5>
                            <b-tooltip :target='data.item._id' triggers="hover" placement="bottom" variant="primary">
                            <span>Printed <span v-if="data.item.printing[0] && data.item.printing[0].username"> by <strong>{{ data.item.printing[0].username }}</strong></span> on <strong v-if="data.item.printing[0] && data.item.printing[0].date">{{moment(data.item.printing[0].date).format('M/D/YYYY h:mma')}}</strong> </span>
                        </b-tooltip>
                        </b-button>

                        <h5 class="mb-0 text-secondary" v-else><b-icon-x-circle-fill></b-icon-x-circle-fill></h5>
                    </span>
                </template>


            </b-table>
        


        </div>
        <customer-builder-modal v-if='showCustomerBuilderModal' :customer="this.customer"  @modalClosed="modalClosed" />
    </div>
    </b-overlay>
    </div>  

</template>

<script>
    import moment from "moment";
    import utils from "../../mixins/utils";
    import CustomerBuilderModal from './CustomerBuilderModal';
    import OrderMenu from '../orders/OrderMenu';
    import customerApi from '../../api/customers';
    import ordersApi from '../../api/orders';

  export default {
      name: "CustomerOrders",
      mixins: [ customerApi, ordersApi, utils ],
      components: { OrderMenu, CustomerBuilderModal },
      props: [ 'customerId', 'customer' ],
      async mounted() {
         await this.fetchOrders();
      },
      data() {
          return {
            orders: [],
            totalOrderAmount: 0,
            totalItemAmount: 0,
            cancelledOrdersCount: 0,
            isLoading: false,
            selected: [],
            selectRange: false,
            showCustomerBuilderModal: false,
            orderCustomer: null,
            creatingOrder: false,
            recentShippingMethod: null,
            fields: [
              { key: 'orderId', label: 'Order', sortable: true, sortDirection: 'desc' },
              {
                  key: 'platform.date',
                  label: 'Date',
                  formatter: date => {
                      if (date) {
                          return moment(date).format('M/D/YYYY h:mma');
                      }

                      return '';
                  },
                  sortable: true, sortDirection: 'desc'
              },
              { key: 'customer.address.line1', label: 'Address'  },
              { key: 'platform.site', label: 'Site', sortable: true },
              {
                  key: 'orderTotal',
                  label: 'Total',
              },
              { key: 'location', label: 'Location' },
              {
                  key: 'printing',
                  label: 'Printed',
                  formatter: printed => printed && printed.length,
              },
              {
                  key: 'shipping',
                  label: 'Shipped',
                  formatter: shipping => shipping.shipments && shipping.shipments.length,
              },
            ],
          }

      },
      methods: {
          async fetchOrders() {
              this.isLoading = true;
              const fetchedOrders = await this.getCustomerOrders(this.customerId);
              this.orders = fetchedOrders;
              const mostRecentOrderByShippingMethod = this.orders.length > 0 ? this.findMostRecentOrderByShippingMethod() : null;
              if (mostRecentOrderByShippingMethod) {
                  this.recentShippingMethod = mostRecentOrderByShippingMethod.shipping.method;
              }
              this.isLoading = false;
          },
          calculateTotal() {
            const validOrders = this.orders ? this.orders.filter(order => order.location !== 'Cancelled') : [];
            this.totalOrderAmount = validOrders.reduce((total, order) => total + (order.orderTotal || 0), 0);
            this.totalItemAmount = validOrders.reduce((total, order) => total + (order.itemTotal || 0), 0);
            this.cancelledOrdersCount = this.orders.reduce((count, order) => count + (order.location === 'Cancelled' ? 1 : 0), 0);
          },
          refreshSearch() {
           this.fetchOrders();
          },
          rowSelected(rows) {
            this.selected = rows;
          },
          setSelectRange() {
            this.selectRange = !this.selectRange;
          },
          async newOrder() {
            if (this.needsCustomerBuilder()) {
              return this.showCustomerBuilderModal = true;

            } else {
            this.creatingOrder = true;
            let date = Date.now();
            const order = await this.createOrder({ 
              shipping: { method: this.recentShippingMethod }, 
              platform: { date: date }, 
              customer: {
                _id: this.customer._id,
                fullName: this.customer.fullName,
                address: this.customer.address && this.customer.address.length > 0 ? this.customer.address[0] : {},
                email: this.customer.email && this.customer.email.length > 0 ? this.customer.email[0] : '',
                phone: this.customer.phone && this.customer.phone.length > 0 ? this.customer.phone[0].number : '',
                customerId: this.customer.customerId || ''
              }
            });
            this.creatingOrder = false;
            return this.$router.push({ name: 'orders', params: { outsideQuery: { orderId: order.orderId.toString(), query: order.orderId.toString(), filters: {} } } });
            }
          },
          async modalClosed(result) {
            this.showCustomerBuilderModal = false;
            if (result) {
              let date = Date.now();
              this.orderCustomer = result;
              // Handle the selected address (result.selectedAddress)
              this.creatingOrder = true;
              const order = await this.createOrder({ shipping: { method: this.recentShippingMethod }, platform: { date: date }, customer: result});
              this.creatingOrder = false;
              return this.$router.push({ name: 'orders', params: { outsideQuery: { orderId: order.orderId.toString(), query: order.orderId.toString(), filters: {} } } });}
             else {
              return
            }
          },
          async previewInvoice() {
            try {
                let orderId = this.prepareOrderIdsForInvoice();

                await this.emailPreviewInvoice(orderId);
                this.showToast('Invoice Preview', 'Sent to your email.');
            } catch (err) {
                this.showError(err, 'Invoice Preview');
            }
            },
          async sendInvoice() {
            try {
              let orderId = this.prepareOrderIdsForInvoice();

              await this.emailInvoice(orderId);
              this.showToast('Invoice Sent', 'Success!');
            } catch (err) {
              this.showError(err, 'Invoice');
            }
          },
          prepareOrderIdsForInvoice() {
            let orderId;

            if (this.selected.length) {
              orderId = this.selected.map(select => {
                  return select.orderId;
              }).join(',');
            } else {
              orderId = this.detailsOrder.orderId;
            }
            return orderId;
          },
          needsCustomerBuilder() {
            return this.customer.address && this.customer.address.length > 1 || this.customer.email && this.customer.email.length > 1 || this.customer.phone && this.customer.phone.length > 1
          },
          async removeCombined() {
            if (!this.selected.length) return;
            try {
              this.isLoading = true;
              for (const order of this.selected) {
                const flags = { ...(order.flags || {}), unmerged: false };
                await this.updateOrder(order.orderId, { flags });
              }
              this.showToast('Remove Combined', `Updated ${this.selected.length} order(s).`);
              await this.fetchOrders();
            } catch (err) {
              this.showError(err, 'Remove Combined');
            } finally {
              this.isLoading = false;
            }
          },
          findMostRecentOrderByShippingMethod() {
            let mostRecentOrder = null;
            for (const order of this.orders) {
                const shippingMethod = order.shipping.method;
                if (shippingMethod && (!mostRecentOrder || order.platform.date > mostRecentOrder.platform.date)) {
                    mostRecentOrder = order;
                }
            }
            return mostRecentOrder;
          },
      },
      watch: {
        // Update the total amount whenever searchResults change
        orders: {
          handler() {
            this.calculateTotal();
          },
          immediate: true, // Calculate the total immediately on component mount
        },
  },

  }
</script>

<style scoped>
  .input-group-text {
      width: 8rem;
  }

  #customerPrintView {
        position: absolute;
        left: -9999px;
        top: -9999px;
    }
    .orders-container {
        display: flex;
        flex-direction: column;
        height: calc(100vh - 200px);
        box-sizing: border-box;
    }

    .order-container {
      height: calc(100vh - 180px);
      overflow-y: auto;
    }

    .orders-table {
        max-height: calc(100% - 20px);
        box-sizing: border-box;
        height: 100%;
    }

    .scrollable-container {
        min-height: 80px;
        overflow: auto;
        flex-grow: 1;
        position: relative;
        
    }

    .print-tooltip-button {
        margin: 0;
        padding: 0;
    }

    .total-amount {
      margin-top: 20px;
      padding: 0;
      list-style: none;
      display: flex;
      flex-direction: row;
    }

    .total-item {
      margin-right: 18px;
    }
</style>